import * as React from "react";
import type { SVGProps } from "react";
const SvgIconDislike = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 1.6q-.27.05-.41.32l-.05.1v7.44c.04.22.22.4.43.44.27.07.56-.09.67-.35l.03-.09V2.11q-.02-.12-.06-.2c-.11-.22-.36-.35-.6-.3m2.13 0c-.18.03-.35.16-.43.32-.03.08-.04.1-.04.25s0 .17.04.24c.05.09.17.22.26.26l.14.05c.06.01 1.41.02 4.95.02 5.17 0 4.94 0 5.09.07.1.05.24.21.28.31q.03.09.47 2.77c.48 2.96.46 2.84.38 3.03-.1.19-.3.34-.5.38l-2.2.01h-2.1l-.09.04c-.13.04-.27.2-.32.32-.04.1-.04.1-.04 1.65L9.01 13q-.06.3-.34.45c-.1.05-.11.06-.26.06s-.17 0-.26-.05l-.17-.12c-.04-.05-.53-.82-1.39-2.2-.8-1.3-1.34-2.15-1.38-2.2l-.15-.1-.08-.04h-.93c-.93 0-.94 0-1.04.03-.13.05-.27.2-.32.32-.05.13-.04.33.01.45s.18.23.29.28l.09.04.7.01h.72l1.2 1.95c.67 1.07 1.25 2 1.3 2.05.23.34.65.62 1.06.7.6.11 1.18-.07 1.6-.5l.2-.23c.1-.15.2-.38.25-.56l.04-.15V11.8l.01-1.36h1.82q1.85 0 1.94-.02c.75-.11 1.34-.65 1.5-1.4.03-.11.04-.2.04-.38 0-.24 0-.29-.44-2.95l-.48-2.86q-.13-.4-.45-.72c-.27-.27-.52-.4-.88-.5l-.15-.03H3.13"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconDislike;
